import type * as FavCache from '@finn-no/favorite-api-browser-client';
import React, { forwardRef } from 'react';
import '@warp-ds/elements/components/toast';
import { Card, Clickable } from '@warp-ds/react';
import { i18n } from '@lingui/core';

// @ts-expect-error this will be fixed by changing to esnext moduleResolution in TS
// but i'm not changing every import in this project just to do that
import IconLandscape56 from '@warp-ds/icons/react/landscape-56';
import { markAsFavorite, removeFavorite } from './ApiCallHandler';
import { toast } from '@warp-ds/elements/toast';

type FolderButtonProps = {
    adExists: boolean;
    itemType: FavCache.ItemType;
    itemId: number;
    api: FavCache.FavoriteBrowserCache;
    closeCallback: () => void;
    folder: FavCache.FavoriteListType;
    handleError: (e: string) => void;
};

const FolderButton = forwardRef(
    (
        {
            adExists,
            itemType,
            itemId,
            api,
            closeCallback,
            folder,
            handleError,
        }: FolderButtonProps,
        _forwardRef: React.Ref<HTMLButtonElement>,
    ) => {
        async function handleToggleFavorite() {
            // clear out any potential error messages, if none exists then it's a no-op
            handleError('');

            if (adExists) {
                await unFavorite();
            } else {
                await addFavorite();
            }
        }

        async function addFavorite() {
            const result = await markAsFavorite({
                api,
                itemType,
                itemId,
                folderId: folder.folderid,
            });
            if (!result.ok) {
                console.error(result.error);
                handleError(
                    i18n.t({
                        id: 'favoriteAddedErrorToast',
                    }),
                );
            } else {
                toast(
                    i18n.t({
                        id: 'favoriteAddedToast',
                        values: { folder: folder.name },
                    }),
                    { type: 'success' },
                );
                closeCallback();
            }
        }

        async function unFavorite() {
            const result = await removeFavorite({
                api,
                itemType,
                itemId,
                folderId: folder.folderid,
            });
            if (!result.ok) {
                console.error(result.error);
                handleError(
                    i18n.t({
                        id: 'favoriteRemovedErrorToast',
                    }),
                );
            } else {
                toast(
                    i18n.t({
                        id: 'favoriteRemovedToast',
                        values: { folder: folder.name },
                    }),
                    { type: 'success' },
                );
                closeCallback();
            }
        }

        return (
            <Card selected={adExists}>
                <div className="grid grid-cols-4 md:grid-cols-3 flex-row">
                    {folder.image ? (
                        <img
                            style={{ aspectRatio: '1/1' }}
                            className="w-full rounded-l-8 object-cover"
                            src={folder.image}
                            alt="Description"
                        />
                    ) : (
                        <IconLandscape56 className="w-full rounded-l-8 p-24 h-full image-aspect object-cover s-icon-subtle s-bg-subtle" />
                    )}
                    <div className="col-span-2 p-16">
                        <Clickable onClick={handleToggleFavorite}>
                            <p className="text-s text-left text-ellipsis line-clamp-2">
                                {folder.name.trim()}
                            </p>
                        </Clickable>
                    </div>
                </div>
            </Card>
        );
    },
);

export default FolderButton;
